import React from 'react';
import GoogleMapReact from 'google-map-react';
import WhiteMarker from '../WhiteMarker';
import cityCoords from '../../constants/city_coordinates.json';
import useWindowSize from '../../hooks/useWindowSize';

export default function MLSShowMap({ coords = cityCoords.destin }) {
  const { width: windowWidth } = useWindowSize();
  const isMobile = windowWidth < 768;
  const iOSDevices = ['iPhone', 'iPad'];

  // Reference: https://medium.com/@colinlord/opening-native-map-apps-from-the-mobile-browser-afd66fbbb8a4
  function mapsSelector() {
    //  open the native maps app on mobile
    if (!isMobile) return;

    if (
      /* if we're on iOS, open in Apple Maps */
      iOSDevices.includes(navigator.platform)
    )
      window.open(
        `maps://maps.google.com/maps?daddr=${coords.lat},${coords.lng}&amp;ll=`
      );
    /* else use Google */ else
      window.open(
        `https://maps.google.com/maps?daddr=${coords.lat},${coords.lng}&amp;ll=`
      );
  }
  return (
    <section className="mls-map-container">
      <div style={{ width: '100%', height: '100%' }}>
        <GoogleMapReact
          onClick={mapsSelector}
          bootstrapURLKeys={{
            // TODO: REPLACE WITH ENV VAR
            key: 'AIzaSyATvnQePj9OTTCZJ6VkugYM8dRGFPJ5HmQ',
          }}
          defaultCenter={coords}
          defaultZoom={12}
          options={{
            zoomControl: false,
            fullscreenControl: false,
          }}
        >
          <WhiteMarker lat={coords.lat} lng={coords.lng} />
        </GoogleMapReact>
      </div>
    </section>
  );
}
